/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class V1OrderLineViantAdelphicIDsSetCreativeID {
    'internalCreativeId'?: string;
    'adelphicCreativeId'?: string;
    'creativeAssetUrl'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "internalCreativeId",
            "baseName": "internal_creative_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "adelphicCreativeId",
            "baseName": "adelphic_creative_id",
            "type": "string",
            "format": "int64"
        },
        {
            "name": "creativeAssetUrl",
            "baseName": "creative_asset_url",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineViantAdelphicIDsSetCreativeID.attributeTypeMap;
    }

    public constructor() {
    }
}

